<template>
  <div class="container-lista">
    <div class="perguntas-container" v-if="respostas && respostas.length > 0">
      <div
        v-for="pergunta in respostas"
        :key="pergunta.descricao"
        class="pergunta-card"
        :class="{
          impedimento:
            !temPermissaoValidarEncerramento && pergunta.resposta === false,
        }"
      >
        <div class="pergunta-header">
          <div class="pergunta-titulo">
            <span class="text-weight-medium">{{ pergunta.pergunta }}</span>
          </div>

          <div class="pergunta-opcoes q-mt-md">
            <q-radio
              :disable="
                pt.status === 'fechado' ||
                pt.status === 'cancelado' ||
                !usuarioPodeEditar
              "
              class="q-mr-md"
              v-model="pergunta.resposta"
              @update:model-value="
                (value, event) =>
                  responderPergunta(value, event, pergunta.encerramentoId)
              "
              v-bind:val="true"
              label="Sim"
            />
            <q-radio
              :disable="
                pt.status === 'fechado' ||
                pt.status === 'cancelado' ||
                !usuarioPodeEditar
              "
              v-model="pergunta.resposta"
              @update:model-value="
                (value, event) =>
                  responderPergunta(value, event, pergunta.encerramentoId)
              "
              v-bind:val="false"
              label="Não"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useQuasar } from "quasar";
import { useStore } from "vuex";
import { ref, watch, computed, nextTick } from "vue";

const columns = [
  {
    name: "pergunta",
    label: "Pergunta",
    align: "left",
    field: (row) => row.pergunta,
    format: (val) => `${val}`,
    sortable: true,
  },
  {
    name: "sim",
    align: "center",
    label: "Sim",
    field: "encerramentoId",
    sortable: false,
  },
  {
    name: "nao",
    align: "center",
    label: "Não",
    field: "encerramentoId",
    sortable: false,
  },
];

export default {
  props: ["pt", "usuarioPodeEditar"],
  emits: ["teste", "respostasAtualizadas"],
  setup(props, { emit }) {
    const store = useStore();
    const quasar = useQuasar();
    const respostaAtividade = ref([]);
    const respostas = ref([]);

    const temPermissaoValidarEncerramento = computed(() => {
      return (
        store.state.autenticacao?.usuarioLogado?.permissoes?.gmapi?.roles?.includes(
          "pdt-validar-encerramento"
        ) || false
      );
    });

    const validacaoEncerramento = computed(() => {
      if (temPermissaoValidarEncerramento.value) {
        return { podeEncerrar: true, mensagem: "" };
      }

      const perguntasNao = respostas.value.filter(
        (pergunta) => pergunta.resposta === false
      );

      if (perguntasNao.length > 0) {
        const perguntasTexto = perguntasNao
          .map((p) => `• ${p.pergunta}`)
          .join("\n");
        return {
          podeEncerrar: false,
          mensagem: `Não é possível finalizar a PT. As seguintes perguntas foram respondidas como "Não":\n\n${perguntasTexto}\n\nApenas usuários com permissão "pdt-validar-encerramento" podem finalizar PTs com respostas negativas no encerramento.`,
        };
      }

      return { podeEncerrar: true, mensagem: "" };
    });

    const responderPergunta = async (value, event, encerramentoId) => {
      try {
        let resposta = await store.dispatch(
          "pdt/responderPerguntaEncerramento",
          {
            ptId: props.pt.ptId,
            encerramentoId: encerramentoId,
            resposta: value,
          }
        );

        const perguntaIndex = respostas.value.findIndex(
          (p) => p.encerramentoId === encerramentoId
        );
        if (perguntaIndex !== -1) {
          respostas.value[perguntaIndex].resposta = value;
        }

        await nextTick();

        emit("respostasAtualizadas", {
          respostas: respostas.value,
          validacao: validacaoEncerramento.value,
        });

        quasar.notify({
          message: resposta.data.resultado.Mensagem,
          color: "positive",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      } catch (error) {
        quasar.notify({
          message: "Ocorreu um erro ao responder a pergunta",
          color: "negative",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const verificarImpedimentoEncerramento = () => {
      return validacaoEncerramento.value;
    };

    const recebePerguntas = () => {
      respostas.value = [];
      respostaAtividade.value.forEach((e) => {
        respostas.value.push(e);
      });
    };

    watch(
      () => props.pt,
      () => {
        respostaAtividade.value = props.pt.respostasEncerramento;
        // observacaoEncerramento.value = props.pt.obsEncerramento;
        recebePerguntas();
      }
    );

    watch(
      respostas,
      () => {
        emit("respostasAtualizadas", {
          respostas: respostas.value,
          validacao: validacaoEncerramento.value,
        });
      },
      { deep: true }
    );

    return {
      columns,
      responderPergunta,
      respostaAtividade,
      respostas,
      temPermissaoValidarEncerramento,
      verificarImpedimentoEncerramento,
      // observacaoEncerramento,
      // enviarObservacaoEncerramento,
    };
  },
};
</script>

<style scoped>
.container-lista {
  padding: 0 16px;
}

.perguntas-container {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  padding: 16px 0;
  width: 100%;
}

.pergunta-card {
  background: white;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  border: 2px solid #e0e0e0;
  transition: all 0.3s ease;
  min-height: 120px;
  flex: 0 1 calc(33.333% - 14px);
  min-width: 250px;
  max-width: calc(33.333% - 14px);
}

.pergunta-card.impedimento {
  border-color: #f44336;
  position: relative;
}

.pergunta-card:hover {
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
  transform: translateY(-2px);
}

.pergunta-card.impedimento:hover {
  box-shadow: 0 4px 16px rgba(244, 67, 54, 0.3);
}

.pergunta-header {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.pergunta-titulo {
  color: #1976d2;
  font-size: 1.1rem;
  font-weight: 600;
  line-height: 1.4;
  word-break: break-word;
  flex: 1;
  margin-bottom: 16px;
}

.pergunta-opcoes {
  display: flex;
  gap: 16px;
  align-items: center;
  margin-top: auto;
}

@media (max-width: 1200px) {
  .perguntas-container {
    grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  }
}

@media (max-width: 900px) {
  .perguntas-container {
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  }
}

@media (max-width: 768px) {
  .container-lista {
    padding: 0 8px;
  }

  .perguntas-container {
    grid-template-columns: 1fr;
    gap: 16px;
    padding: 8px 0;
  }

  .pergunta-card {
    padding: 16px;
    min-height: 100px;
  }

  .pergunta-titulo {
    font-size: 1rem;
    margin-bottom: 12px;
  }

  .pergunta-opcoes {
    gap: 12px;
  }
}

@media (max-width: 480px) {
  .container-lista {
    padding: 0 4px;
  }

  .pergunta-card {
    padding: 12px;
  }

  .pergunta-titulo {
    font-size: 0.95rem;
  }

  .pergunta-opcoes {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
}

@media print {
  .fit {
    display: none;
  }

  .pergunta-card {
    background: transparent !important;
    box-shadow: none !important;
    border: 1px solid #ccc !important;
    break-inside: avoid;
  }
}
</style>
